// Scene library — the registry of available branch scenes.
//
// Adding a new scene:
//   1. Create a new file in this directory exporting a React
//      component that takes `{ tone: SceneTone }` and returns
//      the absolutely-positioned SVG layer.
//   2. Register it in SCENES below.
//   3. Pages can opt in by passing the scene name to <BrandScene>.

import type { ComponentType } from "react";

import { PalmsScene } from "./palms";
import { VinesScene } from "./vines";
import type { SceneTone } from "./types";

export type SceneName = "palms" | "vines";

export const SCENES: Record<SceneName, ComponentType<{ tone: SceneTone }>> = {
  palms: PalmsScene,
  vines: VinesScene,
};

export type { SceneTone } from "./types";
